import { formatDistanceToNow, parseISO } from "date-fns";

export interface DateRange {
  from: Date;
  to: Date;
}

export function formatLastBuiltDate(dateString: string | undefined) {
  // Check for a valid string input
  if (
    !dateString ||
    typeof dateString !== "string" ||
    dateString.trim() === ""
  ) {
    return null;
  }

  // Adjust date string by removing the trailing 'Z' if it contains a timezone offset
  if (dateString.includes("+") && dateString.endsWith("Z")) {
    dateString = dateString.slice(0, -1); // Remove the trailing 'Z'
  }

  // Parse the adjusted date string
  const date = new Date(dateString);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return null;
  }

  // Format the date in "en-US" locale
  const formattedDate = date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  });

  return formattedDate;
}

export function convertISODateToRelativeTime(isoDate: string): string {
  const date = parseISO(isoDate);
  const formattedDate = formatDistanceToNow(date, { addSuffix: false });
  return formattedDate.replace(/^about /i, "");
}
